<template lang="pug">

div
    .four.grouped.fields

        .field
            .ui.radio.checkbox
                input#advice-0(type='radio' value='NO' v-model='model')
                label(for='advice-0') Nein
        .field
            .ui.radio.checkbox
                input#advice-1(type='radio' value='ONE_DAY' v-model='model')
                label(for='advice-1') 1 Tag
        .field
            .ui.radio.checkbox
                input#advice-2(type='radio' value='TWO_DAYS' v-model='model')
                label(for='advice-2') 2 Tage
        .field
            .ui.radio.checkbox
                input#advice-3(type='radio' value='THREE_DAYS' v-model='model')
                label(for='advice-3') 3 Tage

</template>

<script>

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            isInvalid() {
                return false
            },

            model: {
                get() { return this.value },
                set(value) { this.$emit('input', value) }
            }

        },

        created() {
            // ggf. Default-Wert setzen
            if (!['NO', 'ONE_DAY', 'TWO_DAYS', 'THREE_DAYS'].includes(this.value)) {
                this.$emit('input', 'NO')
            }
        },

        methods: {

            validate() {
                return Promise.resolve(true)
            },

        },

        props: {
            value: {
                type: String,
                default: null
            }
        }

    }

</script>
